import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ApiEnv } from './api-env';
import { EnvironmentEnum } from './enums';
import { API_ENVIRONMENT, API_BACKENDS } from './tokens';

/**
 * @public
 */
export function provideGemsApi(loader: () => EnvironmentEnum): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: API_ENVIRONMENT, useFactory: loader },
    { provide: API_BACKENDS, useValue: ApiEnv },
  ]);
}
